// @ts-nocheck
import {Analytics} from "@plaudit/analytics";

export default function init() {
	const analytics = Analytics.getInstance();

	// Cookie helper methods
	var CookiesHelper = {
		set: function(name,value,days) {
			var expires = "";
			if (days) {
				var date = new Date();
				date.setTime(date.getTime() + (days*24*60*60*1000));
				expires = "; expires=" + date.toUTCString();
			}
			document.cookie = name + "=" + (value || "")  + expires + "; path=/";
		},
		get: function(name) {
			var nameEQ = name + "=";
			var ca = document.cookie.split(';');
			for(var i=0;i < ca.length;i++) {
				var c = ca[i];
				while (c.charAt(0)==' ') c = c.substring(1,c.length);
				if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
			}
			return null;
		},
		remove: function(name) {   
			document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
		}
	};
	
	var script = document.querySelector('#signupScript');
	
	if (script) {
		script.addEventListener('load', function () {
			if (SignUpFormWidget) {
				// SignUpFormWidget should always be available at this point. The above if is just being safe.
				// But, SignUpFormWidget.Handlers is likely not yet configured so we have to use a setTiimeout
				var attemptsToInstall = 0;
				var installSubmitHandler = function () {
					if (SignUpFormWidget.Handlers === undefined) {
						if (attemptsToInstall++ < 15) {
							setTimeout(installSubmitHandler, 200);
						}
						return;
					}

					// ConstantContact expects an old version of JQuery. We "polyfill" to solve the potential issue.
					var existingJqueryAjax = jQuery.ajax;	
					jQuery.ajax = function() {
						var xhr = existingJqueryAjax.apply(this, arguments);
						if (xhr.complete === undefined) {
							xhr.complete = xhr.always;
						}
						return xhr;
					};

					// Render Form - Only display form once per 24 hours. Use cookie to know when displayed last.
					if (SignUpFormWidget.Render._doRender !== undefined) {
						SignUpFormWidget.Render._prevDoRender = SignUpFormWidget.Render._doRender;
						SignUpFormWidget.Render._doRender = function(a, form, e, f, g, i) {
							if (CookiesHelper.get('ccFormDisplayed') == 'true' || CookiesHelper.get('ccFormSubmitted_' + form.form_id) == 'true') {
									return jQuery.Deferred();
							}
							CookiesHelper.set('ccFormDisplayed', 'true', 1); // Only display once per 24 hours
							return SignUpFormWidget.Render._prevDoRender(a, form, e, f, g, i);
						};
					}

					// Submit - Intercept the form submitted and use the returned promise from the original form submit function to know when the form was successfully submitted
					var existingSubmitForm = SignUpFormWidget.Handlers.submitForm;
					SignUpFormWidget.Handlers.submitForm = function(token, $elem, form) {
						console.log(token, $elem, form);
						var promise = existingSubmitForm(token, $elem, form);
						promise.then(function() {
							// Track form submission in GA
							analytics.trackEvent("Constant Contact", "Submit", form.form_id);
							CookiesHelper.set('ccFormSubmitted_' + form.form_id, 'true', 999);
						});
						return promise;
					};
				};
				installSubmitHandler();
			}
		});
	}
}